<template>
	<app>
		<crumb-bar></crumb-bar>
		<module>
			<c-title class="g-menu-content-title">政策通知</c-title>
			<empty v-if="emptyState"></empty>
			<div v-else>
				<ul class="notice-list">
					<router-link v-for="(item, i) in dataList" :key="i" :to="`/notice/detail?id=${item.id}`" target="_blank"><li class="flex-between-center">
						<p>{{item.title}}</p>
						<span>{{item.create_date}}</span>
					</li></router-link>
				</ul>
			
				<pagination ref="pagination" :total="total" @handle="updateList"></pagination>
			</div>
		</module>
		
		<c-dialog ref="detail" title="政策通知详情" width="850" height="670" :button="false">
			<h1 class="notice-title">{{noticeContent.title}}</h1>
			<div v-html="noticeContent.content" class="notice-content"></div>
		</c-dialog>
	</app>
</template>

<script>
	import empty from '@/components/public/empty.vue'
	import pagination from '@/components/public/pagination'
	
	export default {
		components: {
			empty,
			pagination
		},
		
		data() {
			return {
				dataList: [],
				total: 1,
				emptyState: false,
				noticeContent: {}
			}
		},
		
		mounted() {
			this.$refs.pagination.update(1);
		},
		
		methods: {
			updateList(page) {
				this.request({
					url: '/announcement/list',
					data: page,
					success: data => {
						this.dataList = data;
						this.emptyState = !data.length && page.pageIndex == 1;
					},
					response: res => {
						this.total = res.total;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.notice {
		&-list {
			li {
				height: 56px;
				border-bottom: 1px solid #eee;
				cursor: pointer;
				
				&:hover {
					p {
						color: #4497F7;
					}
				}
				
				p {
					font-size: 16px;
					color: #666;
				}
				
				span {
					font-size: 14px;
					color: #999;
				}
			}
		}
	}
</style>
